import './NavItemsView.less';
import React, {useState, useEffect} from 'react';
import Icon from "../../../../bootstrap/components/icon/Icon";
import {useLocation, useHistory} from 'react-router-dom';

export default function NavItemsView({activeKey: defaultActiveKey, leveledItems}) {
    const [activeKey, setActiveKey] = useState(defaultActiveKey);

    const [expandedItemKeys, setExpandedItemKeys] = useState(getDefaultExpandedItemKeys());

    const location = useLocation();

    const history = useHistory();

    useEffect(() => {
        setActiveKey(defaultActiveKey);
    }, [defaultActiveKey]);

    useEffect(() => {
        setExpandedItemKeys(getDefaultExpandedItemKeys());
    }, [activeKey]);

    function toggleItemExpanded(key) {
        if (expandedItemKeys.includes(key)) {
            setExpandedItemKeys(expandedItemKeys.filter(k => k !== key));
        } else {
            setExpandedItemKeys(expandedItemKeys.concat(key));
        }
    }

    function getDefaultExpandedItemKeys () {
        const checkShouldExpanded = (items) => {
            const shouldExpanded = items.some(item => item.key === activeKey);

            if (shouldExpanded) {
                return true;
            }

            return items.some(item => item.items ? checkShouldExpanded(item.items) : false);
        };

        const expandedItemKeys = [];
        const initExpandedItems = (items) => {
            items.forEach((item) => {
                if (item.items) {
                    if (checkShouldExpanded(item.items)) {
                        expandedItemKeys.push(item.key);
                        initExpandedItems(item.items, item.key);
                    }
                }
            });
        };
        initExpandedItems(leveledItems);

        return expandedItemKeys;
    }

    function renderItems(items) {
        return <ul>
            {
                items.map(({key, name, url, items}) => {
                    const expandable = items && items.length > 0;
                    const expanded = expandedItemKeys.indexOf(key) >= 0;
                    const active = key === activeKey;

                    const handleToggleClick = (ev) => {
                        if (items && items.length > 0) {
                            toggleItemExpanded(key);
                        }
                        ev.stopPropagation();
                    };

                    const handleLinkClick = (ev) => {
                        if (location.pathname !== url) {
                            history.push(url);
                        }
                        ev.preventDefault();
                    };

                    return <li
                        key={key}
                        className={
                            (expandable ? 'expandable' : '') +
                            (expanded ? ' expanded' : '')
                        }
                    >
                        <div className="inline">
                            <a
                                href={url}
                                onClick={url !== undefined ? handleLinkClick : handleToggleClick}
                                className={active ? 'active' : ''}
                            >
                                <span className="text">{name}</span>
                                {
                                    expandable &&
                                    <button
                                        type="button"
                                        onClick={handleToggleClick}
                                    >
                                        <Icon name={expanded ? 'angle-up' : 'angle-down'}/>
                                    </button>
                                }
                            </a>
                        </div>
                        {
                            expandable && expanded &&
                            <div className="children">
                                {renderItems(items, key)}
                            </div>
                        }
                    </li>;
                })
            }
        </ul>;
    }

    return <div className="nav-items-view">
        {renderItems(leveledItems)}
    </div>;
}

